import { Highlight } from '@curology/ui-components-web/react/Highlight';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { IngredientsAccordion } from '../IngredientsAccordion';
import { ModalImage } from '../ModalImage';
import { ModalPricingVolumeAndProductOptionSelector } from '../ModalPricingVolumeAndProductOptionSelector';

export const DarkSpotFormulaModalContent = ({
  modalCard,
}: {
  modalCard: Card;
}) => {
  const { modal } = modalCard;

  return (
    <>
      <ModalImage modal={modal} />
      <Typography className="cur-mt-4" size="h2">
        {modal.title}
        <sup>Rx</sup>
      </Typography>
      <ModalPricingVolumeAndProductOptionSelector modalCard={modalCard} />
      {modalCard.recommendationText && (
        <Highlight className="cur-mt-4" state="success">
          <div
            dangerouslySetInnerHTML={{
              __html: modalCard.recommendationText.modalCallout,
            }}
          ></div>
        </Highlight>
      )}
      <Typography className="cur-mt-4">
        Fade sun spots, melasma, and more with a custom dark spot corrector—made
        with ingredients you can’t get off the shelf.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        Active ingredients
      </Typography>
      <Typography className="cur-mt-4">
        Your provider will pick custom ingredients, at custom strengths, to
        include in your Dark Spot Formula. Your ingredients may include:
      </Typography>
      <IngredientsAccordion
        body="Blocks the production of excess pigment to help fade dark spots"
        title="Hydroquinone"
      />
      <IngredientsAccordion
        body="Calms irritation like redness, itching, and swelling"
        title="Hydrocortisone"
      />
      <IngredientsAccordion
        body="Brightens skin to help even out skin tone"
        title="Kojic acid"
      />
      <IngredientsAccordion
        body="Gently exfoliates and reduces excess pigment to help smooth and brighten skin"
        title="Azelaic acid"
      />
      <IngredientsAccordion
        body="Regulates pigment production and provides antioxidant protection"
        title="Resveratrol"
      />
      <IngredientsAccordion
        body="Minimizes hyperpigmentation and fights damaging free radicals"
        title="Green tea extract (epigallocatechin gallate)"
      />
      <Typography className="cur-mt-4" size="h3">
        Inactive ingredients
      </Typography>
      <Typography className="cur-mt-4">
        Aqua purificata, Cetearyl alcohol, Polysorbate 60, Isohexadecane,
        Isododecane, C13-C15 alkane, Glyceryl stearate, PEG-75 stearate,
        Polyacrylate-13, Polyisobutene, Polysorbate 20, Polyurethane-39, Stearyl
        behenate, Cetyl alcohol, Tocopheryl acetate, Ascorbic acid, Sodium
        Bisulfite, Benzoic acid (0.09%), Sorbic acid (0.09%), Propanediol,
        Butylated hydroxytoluene (BHT)
      </Typography>
    </>
  );
};
